<template>
    <div>
        <h2 class="title">Clinical Supervisions Report</h2>

       
        <div class="notification is-warning" v-if="loading == true">
            Loading members ...
        </div>
        <div class="notification is-danger" v-if="loading == false && members.length == 0">
            No active members can be found that require Clinical Supervisions
        </div>

        <table class="table is-fullwidth is-hoverable" v-if="loading == false && this.members.length > 0">
            <thead>
                <tr>
                    <th width="50"></th>
                    <th>Forename</th>
                    <th>Surname</th>
                    <th>Approved Date</th>
                    <th>Last Supervision</th>
                    <th>Last Invited</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in this.members" :key="row.id" :class="{'has-background-danger-dark' : row.blocked==1, 'has-text-white' : row.blocked==1}">
                    <td><router-link :to="'/members/' + row.id" target="_blank"><button class="button is-small is-link" >View</button></router-link></td>
                    <td>{{ row.forename }}</td>
                    <td>{{ row.surname}}</td>
                    <td>{{ row.approved_date | formatUKDate}}</td>
                     <td>{{ row.last_clinical_supervision_date | formatUKDate}}</td>
                     <td>{{ getLastInviteDate(row) | formatUKDate}}</td>
                    <td>
                        <span class="tag is-danger" v-if="checkDate(row.last_clinical_supervision_date)">Expired</span>
                        <span class="tag is-warning" v-if="row.last_clinical_supervision_date == '' || row.last_clinical_supervision_date == null">Not Set</span>
                        <span class="tag is-success" v-if="!checkDate(row.last_clinical_supervision_date) && row.last_clinical_supervision_date != '' && row.last_clinical_supervision_date != null">Valid</span>
                    </td>
                </tr>
                
                
            </tbody>
            
        </table>

       
    </div>
</template>

<script>
//import MemberService from '@/services/MemberService.js';
import MemberMixin from '@/mixins/MemberMixin.js';

//import MemberGradeTags from '@/components/Generic/MemberGradeTags.vue';

export default {
    
      name: 'MembersDashboard',
        mixins: [MemberMixin],
        components: {
            //MemberGradeTags
        },
        data: function () {
            return {
                   search: '',
                   members: [],
                   loading: false,
                  
                   showModal: false,
                   order_by: "last_clinical_supervision_date ASC"
            }
        },
        methods: {
            getLastInviteDate(row) {
                const invites = (row.dates || []).filter(d => d.date_type == 'clinical_supervision_invite')
                if (invites.length == 0) {
                    return null
                }
                return invites.reduce((latest, current) => (current.date > latest.date ? current : latest)).date
            },
            checkDate(checkDate) {
                if(checkDate != '' && checkDate != null)
                {
                    const sqlDateParts = checkDate.split('-');
                    const sqlTimestamp = new Date(sqlDateParts[0], sqlDateParts[1] - 1, sqlDateParts[2]);

                    if (Number.isNaN(sqlTimestamp.getTime())) {
                        return false
                    }

                    const expiryTimestamp = new Date(sqlTimestamp);
                    expiryTimestamp.setFullYear(expiryTimestamp.getFullYear() + 1);

                    const targetTimestamp = new Date();

                    return targetTimestamp > expiryTimestamp
                }
                else {
                    return false
                }
                
            },
        },
        created() {
            this.getAccessToken()
            .then(() => { 
                this.getNmcMembers(this.order_by)
            });
        
        },
    }
</script>